function countryHasStateProvinceCode(countryId) {
    let countryIdAsString = countryId;
    if (typeof countryId === "number") {
        countryIdAsString = countryId + "";
    }
    return countryIdAsString === constants.countryIds.UnitedStates || countryIdAsString === constants.countryIds.Canada;
}
